import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
( function( app ) {
  const COMPONENT = {
    className: 'locations-block',
    selector() {
      return '.' + this.className;
    },

    init() {
      const component = document.querySelector( this.selector() );
      if ( !component ) return;

      const sliderEl = component.querySelector( '.locations-slider' );
      if ( !sliderEl ) return;

      const splide = new Splide( sliderEl, {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: '32px',
        breakpoints: {
          1024: {perPage: 2},
          640: {perPage: 1},
        },
        pagination: false,
        arrows: false,
        drag: true,
      } );

      splide.mount();

      const prevBtn = component.querySelector( '.splide__arrow--prev' );
      const nextBtn = component.querySelector( '.splide__arrow--next' );

      if ( prevBtn ) {
        prevBtn.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          splide.go( splide.index - 1 );
        } );
      }

      if ( nextBtn ) {
        nextBtn.addEventListener( 'click', ( e ) => {
          e.preventDefault();
          splide.go( splide.index + 1 );
        } );
      }
    },

    finalize() {},
  };

  app.registerComponent( 'locations-block', COMPONENT );
} )( app );
